import { Component, EventEmitter, input, Output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FieldFieldComponent, FieldMappingComponent, FieldRowComponent } from '@r1-compass-library/components';
import { SalesforceField, SalesforceObjectMetadata } from '@r1-compass-library/models';
import { FileMappingRowForm } from '@r1-compass-library/models/play/play-file-import-form.model';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'r1-compass-app-file-mapping-row',
    imports: [
        FontAwesomeModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonToggleModule,
        ReactiveFormsModule,
        FieldMappingComponent,
        FieldRowComponent,
        FieldFieldComponent,
        MatInput,
    ],
    templateUrl: './file-mapping-row.component.html',
    styleUrl: './file-mapping-row.component.scss',
})
export class FileMappingRowComponent {
    rowFormGroup = input.required<FormGroup<FileMappingRowForm>>();

    readonly rowIndex = input.required<number>();

    readonly playFields = input<SalesforceField[]>([]);

    readonly recommendationFields = input<SalesforceField[]>([]);

    readonly csvHeaders = input<string[] | undefined>([]);

    readonly salesforceUniqueRecommendationFieldTargetOption = input.required<SalesforceObjectMetadata>();

    readonly existingMappedFields = input<FormArray<FormGroup<FileMappingRowForm>>>();

    @Output()
    deleteFileMappingRow: EventEmitter<void> = new EventEmitter();

    @Output()
    sourceFieldNameSelected: EventEmitter<string> = new EventEmitter();

    @Output()
    recommendationFieldNameSelected: EventEmitter<string> = new EventEmitter();

    protected readonly faTrash = faTrash;

    protected onDelete() {
        this.deleteFileMappingRow.emit();
    }

    protected onSourceFieldNameSelected(value: string) {
        //we only care about tracking the first row, which is the unique one
        if (this.rowIndex() === 0) {
            this.sourceFieldNameSelected.emit(value);
        }
    }

    protected onRecommendationFieldNameSelected(value: string) {
        //we only care about tracking the first row, which is the unique one
        if (this.rowIndex() === 0) {
            this.recommendationFieldNameSelected.emit(value);
        }
    }

    protected fieldAlreadyInUse(field: SalesforceField): boolean {
        return (
            (this.salesforceUniqueRecommendationFieldTargetOption().name === field.name ||
                this.existingMappedFields()?.controls.some(
                    mappedFieldFormGroup => mappedFieldFormGroup.controls.recommendationFieldName.value === field.name
                )) ??
            false
        );
    }
}
